import { redirect } from "react-router-dom";

export const getExpDuration = () => {
    const expDate = localStorage.getItem("exp");
    const expDateInMili = new Date(expDate);
    const currentDateInMilli = new Date();
    const duration = expDateInMili - currentDateInMilli;
    return duration;
};

export const getEnv = () => {
    const token = localStorage.getItem("env");
    if (
        !token ||
        token !==
            "3323ce38138a11c33172668cfe999a7c6ab611c6ab6e228a5ff3b1f72af34531"
    ) {
        return null;
    }
    const duration = getExpDuration();
    if (duration < 0) {
        localStorage.removeItem("env");
        localStorage.removeItem("exp");
        localStorage.removeItem("officeId");
        localStorage.removeItem("vlgId");
        alert("Token Expired!");
        return null;
    }
    const expDate = new Date();
    expDate.setHours(expDate.getHours() + 1);
    localStorage.setItem("exp", expDate.toISOString());
    return token;
};

export const loader = () => {
    return getEnv();
};

export const checkEnv = () => {
    const token = getEnv();
    if (
        !token ||
        token !==
            "3323ce38138a11c33172668cfe999a7c6ab611c6ab6e228a5ff3b1f72af34531"
    ) {
        return redirect("/env");
    }
    return null;
};

export const homeRouteEnv = () => {
    const token = getEnv();
    if (
        token &&
        token !==
            "3323ce38138a11c33172668cfe999a7c6ab611c6ab6e228a5ff3b1f72af34531"
    ) {
        return redirect("/");
    }
    return null;
};
